import { Mutations } from "./global.types";

export default {
  [Mutations.SET_MOBILE](state, status) {
    state.isMobile = status;
  },
  [Mutations.SET_TABLET](state, status) {
    state.isTablet = status;
  },
  [Mutations.SET_TABLET](state, status) {
    state.isTablet = status;
  },
  [Mutations.SET_DESKTOP](state, status) {
    state.isDesktop = status;
  },
  [Mutations.SET_USER_TASKS](state, tasks) {
    state.userTasks = tasks;
  },
  [Mutations.SHOW_SPINNER](state) {
    state.spinnerVisible = true;
  },
  [Mutations.HIDE_SPINNER](state) {
    state.spinnerVisible = false;
  },
  [Mutations.UPDATE_CAMPAIGN](state, campaign) {
    state.campaign = campaign;
  },
  [Mutations.SET_USER_PROFILE](state, user) {
    state.user = user;
  },
  [Mutations.SET_SURVEY_PROFILE](state, surveyProfile) {
    state.surveyProfile = surveyProfile;
  },
  updateColors(state, colors) {
    state.colors = colors;
  }
};
